<template>
  <div
    class="app_card menu-item"
    @click="openLink">
    <div class="gradient-border">
      <div class="app_icon">
        <app-image
          customClass="app_icon_img"
          :src="img"
          :alt="title"/>
      </div>
    </div>
    <div class="app_content">
      <div class="app_content_title">{{title}}</div>
      <div class="app_content_desc"><p>{{scontent}}</p></div>
      <div class="app_content_times">
        <img
          src="@/assets/image/download-times.svg"
          alt="up"/> {{invented_count}}次</div>
    </div>
    <div class="app_download">
      <span class="download_button">观看</span>
    </div>
  </div>
</template>

<script>
import { toRefs } from '@vue/composition-api'
import { device, deviceType, randomSubDomain } from '@/utils'
import AppImage from '../AppImage.vue'
export default {
  name: 'AppCard',
  components: { AppImage },
  props: {
    img: String,
    title: String,
    scontent: String,
    android_url: String,
    ios_url: String,
    invented_count: [String, Number]
  },
  setup (props) {
    const { ios_url: iosUrl, android_url: androidUrl } = toRefs(props)
    const openLink = () => {
      if (device() === deviceType.ios) {
        window._paq.push(['trackLink', iosUrl.value, 'link'])
        window.open(randomSubDomain(iosUrl.value), '_blank')
      } else {
        window._paq.push(['trackLink', androidUrl.value, 'link'])
        window.open(randomSubDomain(androidUrl.value), '_blank')
      }
    }

    return {
      openLink
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  &_card {
    box-sizing: border-box;
    display: flex;
    width: 100%;
    height: 107.5px;
    padding: 12px 15px;
    border-bottom: 1px solid rgba(157, 83, 83, 0.4);
  }

  &_icon {
    width: 80px;
    height: 80px;
    overflow: block;

    /deep/ &_img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      transform: translate(2px, 2px);
    }
  }

  &_content {
    display: flex;
    flex: 2;
    flex-direction: column;
    justify-content: center;
    width: 160px;
    margin: 0 18px 0 14px;
    text-align: left;

    &_title {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: $other-title;
    }

    &_desc {
      display: flex;
      align-items: center;
      width: 100%;

      p {
        display: -webkit-box;
        margin: 4px 0 8px 0;
        overflow: hidden;
        font-size: 12px;
        line-height: 16px;
        color: $other-description;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    &_times {
      > img {
        width: 10px;
        height: 10px;
        transform: translate(0, 1px);
      }

      font-size: 12px;
      line-height: 16px;
      color: $other-times;
    }
  }

  &_download {
    display: flex;
    align-items: center;
    width: 18%;
  }
}

.gradient-border {
  position: relative;
  z-index: 0;
  width: 80px;
  height: 80px;
}

.gradient-border::before {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  padding: 2px;
  content: "";
  background: linear-gradient(to bottom, #7b39c2, #ff7272); /* 紫藍漸層 */
  border-radius: 13px;
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out;
  mask-composite: exclude;
}

.menu-item {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

/* 流動光線效果 */
.menu-item::before {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  content: '';
  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255, 107, 157, 0.3),
      rgba(255, 255, 255, 0.2),
      rgba(255, 107, 157, 0.3),
      transparent
    );
  animation: flowingLight 4s infinite;
  animation-delay: var(--delay, 0s);
}

.menu-item:nth-child(1) { --delay: 0s; }
.menu-item:nth-child(2) { --delay: 0.5s; }
.menu-item:nth-child(3) { --delay: 1s; }
.menu-item:nth-child(4) { --delay: 1.5s; }
.menu-item:nth-child(5) { --delay: 2s; }
.menu-item:nth-child(6) { --delay: 2.5s; }
.menu-item:nth-child(7) { --delay: 3s; }
.menu-item:nth-child(8) { --delay: 3.5s; }
.menu-item:nth-child(9) { --delay: 4s; }
.menu-item:nth-child(10) { --delay: 4.5s; }

@keyframes flowingLight {
  0% {
    left: -100%;
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    left: 100%;
    opacity: 0;
  }
}
</style>
